module.exports = __webpack_public_path__ + "static/img/ddjx-02.fb781ac7.jpg";